<!--Отображает информацию по выбранному МО-->
<template>
  <v-card v-if="isLoading === false" style="margin-top: 25px; margin-right: 10px" :elevation = "5">
    <v-container>
      <div slot="header" class="subheading" style="padding-top: 10px">
       {{ regionInfo }}
      </div>
      <v-card style="margin-top: 10px" outlined>
        <v-data-table
          hide-default-footer
          :headers="headersGeneral"
          :items="this.generalInformation"
        />
      </v-card>
      <div slot="header" class="subheading" style="padding-top: 30px">
        Комплексная оценка экологической обстановки (По данным статистической отчетности)
      </div>
      <v-card style="margin-top: 10px" outlined>
        <v-data-table
            hide-default-footer
            :headers="headersEnvironmentalAssessment"
            :items="this.environmentalAssessment"
        />
      </v-card>
    </v-container>
  </v-card>
  <v-layout style="justify-content: space-around; margin-bottom: 50px; margin-top: 50px" v-else>
    <vue-simple-spinner line-fg-color="#3f51b5" size="big"  />
  </v-layout>
</template>

<script>
import axios from "axios";
import Spinner from "vue-simple-spinner/src/components/Spinner";

export default {
  name: "RegionInfo",
  components: {
    "vue-simple-spinner": Spinner,
  },
  props: {
    regionId: Number,
    activeYear: Number,
  },
  data() {
    return {
      regionInfo: [],
      isLoading: true,
      generalInformation: [],
      environmentalAssessment: [],
      headersGeneral: [
        { text: "Административный центр: ", align: "center", sortable: false, value: "center"},
        { text: "Дата образования",  align: "center", sortable: false, value: "createDate" },
        { text: "Численность населения, чел",  align: "center", sortable: false, value: "population" },
        { text: "Площадь территории, кв.км",  align: "center", sortable: false, value: "area" }
      ],
      headersEnvironmentalAssessment: [
        { text: "Валовые выбросы, тонн", align: "center", sortable: false, value: "grossEmissions"},
        { text: "Объем забранной воды, млн куб.м", align: "center", sortable: false, value: "withdrawnWater" },
        { text: "Объем водоотведения млн куб.м", align: "center", sortable: false, value: "dischargeVolume" },
        { text: "Масса образованных отходов, тонн", align: "center", sortable: false, value: "formedWaste" }
      ],
    };
  },
  methods: {
    getInfo(year, regionId) {
      this.isLoading = true
      axios
        .post("/eco-passport/get-municipality-info", {year, regionId})
        .then(response => {
          if (response.data.id !== 0) {
            this.regionInfo = response.data.isTown ? " Информация по городскому округу" : "Информация по муниципальному району";
          } else {
            this.regionInfo = " Информация по муниципальному образованию"
          }
          this.generalInformation.push({center: response.data.generalInformation.center,
            createDate: response.data.generalInformation.createDate,
            population: response.data.generalInformation.population,
            area: response.data.generalInformation.area})
          this.environmentalAssessment.push({grossEmissions: response.data.environmentalAssessment.grossEmissions,
            withdrawnWater: response.data.environmentalAssessment.withdrawnWater,
            dischargeVolume: response.data.environmentalAssessment.dischargeVolume,
            formedWaste: response.data.environmentalAssessment.formedWaste})
          this.isLoading = false
        })
        .catch(e => alert(e.toString()));
    },
  },
  created() {
    this.getInfo(this.activeYear, this.regionId)
  },
};
</script>

<style scoped></style>
